import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row, InputNumber } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import {
	createUnitOfMeasureItems,
	updateUnitOfMeasureItems,
} from 'services/settings/lookup_table/unitOfMeasure';

const UnitOfMeasureForm = ({ buttonNames, selecetedData, onDrawerClose, onSuccessCreate, onSuccessUpdate, maxUnitOfMeasureSort }) => {
	console.log(selecetedData);

	const onFinish = async values => {
		const payload = {
			unitOfMeasureCode: values.unitOfMeasureCode,
			unitOfMeasureBase: values.unitOfMeasureBase,
			unitOfMeasureFrom: values.unitOfMeasureFrom,
			unitOfMeasureOperator: values.unitOfMeasureOperator,
			unitOfMeasureFactor: values.unitOfMeasureFactor,
			is_active: values.is_active === true ? 1 : 0,
			// For UPDATE: keep existing sort, For CREATE: use maxUnitOfMeasureSort + 1
			unitOfMeasureSort: selecetedData ? selecetedData.unitOfMeasureSort : (maxUnitOfMeasureSort ? maxUnitOfMeasureSort + 1 : 1),
		};

		console.log(payload);

		if (buttonNames === 'ADD') {
			const created = await createUnitOfMeasureItems(payload);
			if (created) {
				onSuccessCreate();
			}
		} else {
			payload.unitOfMeasureID = selecetedData.unitOfMeasureID;
			const updated = await updateUnitOfMeasureItems(payload);
			if (updated) {
				onSuccessUpdate();
			}
		}
	};

	return (
		<div>
			<Form
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					unitOfMeasureCode: selecetedData ? selecetedData.unitOfMeasureCode : null,
					unitOfMeasureBase: selecetedData ? selecetedData.unitOfMesureBase : null,
					unitOfMeasureFrom: selecetedData ? selecetedData.unitOfMeasureFrom : null,
					unitOfMeasureOperator: selecetedData ? selecetedData.unitOfMeasureOperator : null,
					unitOfMeasureFactor: selecetedData ? selecetedData.unitOfMeasureFactor : null,
					is_active: selecetedData ? (selecetedData.isActive === 1 ? true : false) : true,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="is_active" valuePropName="checked">
							<Switch disabled={buttonNames === 'ADD'} />
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label="UNIT CODE"
					name="unitOfMeasureCode"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={10}/>
				</Form.Item>
				<Form.Item
					label="UNIT BASE"
					name="unitOfMeasureBase"
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="UNIT FROM"
					name="unitOfMeasureFrom"
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="OPERATOR"
					name="unitOfMeasureOperator"
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="FACTOR"
					name="unitOfMeasureFactor"
				>
					<InputNumber style={{ width: '100%' }} />
				</Form.Item>
				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>
						CANCEL
					</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default UnitOfMeasureForm;
